<template>
<v-card width='300' >
  <v-card-title class='overline py-1 grey lighten-4 overline' >
    {{title}}
    <v-spacer/>
    <v-btn @click='$emit("close")' icon small ><v-icon small >close</v-icon></v-btn>
  </v-card-title>
  <v-divider/>
  <v-card-text>
    <template v-if='practitionerIds.length > 0' >
      <v-subheader class='overline pl-0' >Practitioner</v-subheader>
      <v-checkbox dense hide-messages
        v-for='(count, practitionerId) in this.facets.practitioner_id'
        class='ma-0 pa-0 caption'
        :key='practitionerId'
        :value='practitionerId'
        :label='getPractitionerLabel(practitionerId, count)'
        v-model='selectedPractitioners' />
    </template>

    <slot></slot>
    <!-- {{selectedPractitioners}} -->
  </v-card-text>
</v-card>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  name: 'InvoiceFilter',
  props: {
    title: { type: String, default: 'filter results' },
    facets: { type: Object, default: () => { return {} } },
    params: { type: Object, default: () => { return {} } }
  },
  data () {
    return {
      selectedPractitioners: []
    }
  },
  computed: {
    ...mapGetters(['getPractitionerById', 'getSpaceById']),
    practitionerIds () {
      if (this.facets && this.facets.practitioner_id) {
        return Object.keys(this.facets.practitioner_id)
      }
      return []
    },
    computedParams () {
      let params = {}
      if (this.selectedPractitioners && this.selectedPractitioners.length > 0) {
        params['practitioner_id-in'] = this.selectedPractitioners.join(',')
      }
      return params
    }
  },
  watch: {
    selectedPractitioners () {
      this.$emit('update:params', this.computedParams)
    }
  },
  methods: {
    getPractitionerLabel (practitionerId, count) {
      let p = this.getPractitionerById(practitionerId)
      if (p && p.id) {
        return `${p.full_name} (${count})`
      }
      return `${practitionerId} (${count})`
    }
  }
}
</script>



// WEBPACK FOOTER //
// InvoiceFilter.vue?44838738